import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const PersistentInviteSpaceFragment: GraphQLTaggedNode = graphql`
	fragment PersistentInviteEligibleQuery_space on Space {
		id
		currentUser {
			isAnonymouslyAuthorized
		}
	}
`;

export const PersistentInviteLicenseFragment: GraphQLTaggedNode = graphql`
	fragment PersistentInviteEligibleQuery_license on License {
		licenseConsumingUserCount
		trialEndDate
	}
`;

export const PersistentInviteEligibleQuery: GraphQLTaggedNode = graphql`
	query PersistentInviteEligibleQuery(
		$spaceKey: String
		$skipLicenseQuery: Boolean!
		$skipSpaceQuery: Boolean!
	) {
		space(key: $spaceKey) @skip(if: $skipSpaceQuery) {
			...PersistentInviteEligibleQuery_space @relay(mask: false)
		}
		license @skip(if: $skipLicenseQuery) {
			...PersistentInviteEligibleQuery_license @relay(mask: false)
		}
	}
`;
